import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { TaskAnalytics } from '@portal-core/task-analytics/models/task-analytics.model';

@CollectionStateSelectors({
  stateType: TaskAnalyticsState
})
@State<TaskAnalyticsState>({
  name: TaskAnalyticsState.source
})
@Service({ autoProvided: false })
export class TaskAnalyticsState extends CollectionStateBase {
  static override source = 'TaskAnalytics';
  getSource(): string {
    return TaskAnalyticsState.source;
  }
}

@Service()
export class TaskAnalyticsDataService extends CollectionDataServiceBase<TaskAnalytics> {
  protected readonly stateType = TaskAnalyticsState;
}
